import { Address } from './Address/Address';
import { ClientDetails } from './client/client-details';
import { ProviderDetails } from './provider/provider-details';
import { Representative } from './Representative/representative';

export interface Business {
  addresses?: Address[];
  aliases?: string[];
  businessTypes: number[];
  clientDetails?: ClientDetails;
  code?: string;
  createdBy?: string;
  createdDate?: string;
  id?: string;
  leadAssociateUserName?: string;
  lotNumbers?: string[];
  modifiedBy?: string;
  modifiedDate?: string;
  name: string;
  providerDetails?: ProviderDetails;
  representatives?: Representative[];
  taxIndicatorCode?: string;
}

export interface BusinessSearchCommand {
  name?: string;
  code?: string;
  businessTypes?: number[];
}

export enum BusinessEntityType {
  Provider,
  Client,
  Manufacturer,
  Consignee,
  Brand,
  InternalCompany,
}
